module.exports = __webpack_public_path__ + "fonts/open-sauce-sans-latin-400-normal.9ffeef2.woff2";